import { transformCurrencyAmountDto } from './currency-amount';
export const transformFeaturedCollectionOrder = dto => ({
  id: dto.id,
  effectiveDays: dto.effective_days,
  maxActiveCollectionsCount: dto.max_active_count,
  planPricingId: dto.pricing_id,
  termsNote: dto.terms_note,
  payableAmount: transformCurrencyAmountDto(dto.payable_amount),
  salesTax: dto.sales_tax ? transformCurrencyAmountDto(dto.sales_tax) : null,
  isTaxCovered: dto.tax_covered,
  isTaxCoverageAvailable: dto.tax_coverage_available
});